import * as React from "react";
import Chip from "@material-ui/core/Chip";
import "./Categories.css";

interface Props {
	categories: {
		id: string | number;
		name: string;
		count: number;
	}[];
	selectedCategory?: string | number;
	setCategory: (categoryId: string | number) => void;
	removeCategory: () => void;
}

const Categories: React.FC<Props> = (props) => {
	return (
		<div className="categories">
			<div className="categories__wrapper">
				{props.categories.map((category, index) => {
						return (
							<Chip
								clickable={true}
								label={category.name}
								key={index}
								onDelete={category.id === props.selectedCategory ? () => props.removeCategory() : null}
								onClick={() => props.setCategory(category.id)}
								classes={{
									root: "categories-chip",
								}}
							/>
						);
					})
				}
			</div>
		</div>
	);
};

export default Categories;
